import * as types from '../mutation-types';

const namespaced = true;

// state
const state = {
  show: false,
  type: '',
  carId: 0
};

// getters
const getters = {
  show: state => state.show,
  type: state => state.type,
  carId: state => state.carId
};

// mutations
const mutations = {
  [types.SHOW_CALL_REQUEST](state, payload) {
    state.show = payload.show;
    state.type = payload.type;
    state.carId = payload.carId;
  },
};

//actions
const actions = {
  show({commit}, payload) {
    commit(types.SHOW_CALL_REQUEST, payload);
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};